import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_photostation } from "../shared/data.service";
import { LocalstorageService } from "../../../../shared/services/localstorage.service";

import { wsPrintSchoolPrinterInfo } from "../shared/wsPrintSchoolOptionsInfo";
import { wsPrintSchoolTemplateInfo } from "../shared/wsPrintSchoolOptionsInfo";

import { wsPrintSchoolOptionsInfoParm } from "../shared/wsPrintSchoolOptionsInfoParm";
import { wsPrintSchoolOptionsInfo } from "../shared/wsPrintSchoolOptionsInfo";
import { wsPhotoStationValidateReleaseInfoParm } from "../shared/wsPhotoStationValidateReleaseInfoParm";
import { wsPhotoStationValidateReleaseInfo } from "../shared/wsPhotoStationValidateReleaseInfo";
import { wsPhotoStationPrintParm } from "../shared/wsPhotoStationPrintParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./print.component.html",
	styleUrls: ["./print.component.css"],
})
export class PrintComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_photostation,
		private localstorageService: LocalstorageService,
		public ref: DynamicDialogRef,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public isOneCardExpressOperator: boolean;

	public SchoolID: number;
	public PersonID: number;
	public PersonName: string;
	public IsStaff: boolean;
	public IsChargePrintFee: boolean;
	public PrintFee: number;
	public SelectedPriority: number = 0;

	public rPrintSchoolOptions: wsPrintSchoolOptionsInfo;
	public rPhotoStationValidateRelease: wsPhotoStationValidateReleaseInfo;

	public lstPrinter: wsPrintSchoolPrinterInfo[] = [];
	public SelectedPrinter: wsPrintSchoolPrinterInfo;
	public saveIDPrinterID: number;

	public lstTemplate: wsPrintSchoolTemplateInfo[] = [];
	public SelectedTemplate: wsPrintSchoolTemplateInfo;
	public saveStudentIDCardTemplateID: string;
	public saveStaffIDCardTemplateID: string;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.PersonName = this.dialogConfig.data.Name;
		this.IsStaff = this.dialogConfig.data.IsStaff;

		this.saveIDPrinterID = this.localstorageService.getItem("PhotoStation_IDPrinterID_" + this.SchoolID + "_" + this.UserPersonID);
		this.saveStudentIDCardTemplateID = this.localstorageService.getItem("PhotoStation_Student_IDCardTemplateID_" + this.SchoolID + "_" + this.UserPersonID);
		this.saveStaffIDCardTemplateID = this.localstorageService.getItem("PhotoStation_Staff_IDCardTemplateID_" + this.SchoolID + "_" + this.UserPersonID);

		let parms: wsPrintSchoolOptionsInfoParm = {
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.IDPrintSchoolOptionsGet(parms).subscribe((data) => this.IDPrintSchoolOptionsGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintSchoolOptionsGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintSchoolOptionsGet_Complete(data: any) {
		this.rPrintSchoolOptions = data;

		this.PrintFee = this.rPrintSchoolOptions.ReprintFee;
		this.lstPrinter = this.rPrintSchoolOptions.Printers;

		if (this.IsStaff == true) {
			this.lstTemplate = this.rPrintSchoolOptions.StaffTemplates;
		} else {
			this.lstTemplate = this.rPrintSchoolOptions.StudentTemplates;
		}

		if (this.lstPrinter.length > 0 && this.lstTemplate.length > 0) {
			//
			//	Set Printer
			//
			var isPrinterFound: boolean = false;

			this.lstPrinter.forEach((item) => {
				if (this.saveIDPrinterID == item.IDPrinterID && isPrinterFound == false) {
					this.SelectedPrinter = item;
					isPrinterFound = true;
				}
			});

			if (isPrinterFound == false) {
				this.SelectedPrinter = this.lstPrinter[0];
			}

			//
			//	Set Template
			//
			var isTemplateFound: boolean = false;
			var IDCardTemplateID: string = "";

			if (this.IsStaff == true) {
				IDCardTemplateID = this.saveStaffIDCardTemplateID;
			} else {
				IDCardTemplateID = this.saveStudentIDCardTemplateID;
			}

			this.lstTemplate.forEach((item) => {
				if (IDCardTemplateID == item.IDCardTemplateID && isTemplateFound == false) {
					this.SelectedTemplate = item;
					isTemplateFound = true;
				}
			});

			if (isTemplateFound == false) {
				this.SelectedTemplate = this.lstTemplate[0];
			}

			//
			//	Validate
			//
			let parms: wsPhotoStationValidateReleaseInfoParm = {
				UserPersonID: this.UserPersonID,
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
				IDCardTemplateID: this.SelectedTemplate.IDCardTemplateID,
			};

			this.isBusy = true;
			this.dataService.PhotoStationValidateRelease(parms).subscribe((data) => this.PhotoStationValidateRelease_Complete(data));
		} else {
			this.isBusy = true; // Keep Print Button Disabled
			this.ErrorMessage = "There are No Printers defined for this school or there are no ID cards defined for this school.";
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationValidateRelease_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationValidateRelease_Complete(data: any) {
		this.rPhotoStationValidateRelease = data;

		this.isOneCardExpressOperator = this.rPhotoStationValidateRelease.isOneCardExpressOperator;

		if (this.isOneCardExpressOperator == true) {
			this.ErrorMessage =
				"PhotoStation printing is disabled for OneCard Express operators. Your user security has you set as a OneCard Express operator.";
		} else {
			if (this.rPhotoStationValidateRelease.isStockOK == true) {
				this.ErrorMessage = "";
			} else {
				this.ErrorMessage =
					"You are about to print using card stock [" +
					this.rPhotoStationValidateRelease.IDCardStockDesc +
					"]. But there are cards released to the print queue that are using a different card stock.";
			}
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrinterChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPrinterChange(value) {
		if (this.lstPrinter.length > 0 && this.lstTemplate.length > 0) {
			this.SelectedPrinter = value;

			let parms: wsPhotoStationValidateReleaseInfoParm = {
				UserPersonID: this.UserPersonID,
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
				IDCardTemplateID: this.SelectedTemplate.IDCardTemplateID,
			};

			this.isBusy = true;
			this.dataService.PhotoStationValidateRelease(parms).subscribe((data) => this.PhotoStationValidateRelease_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTemplateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTemplateChange(value) {
		if (this.lstPrinter.length > 0 && this.lstTemplate.length > 0) {
			this.SelectedTemplate = value;

			let parms: wsPhotoStationValidateReleaseInfoParm = {
				UserPersonID: this.UserPersonID,
				IDPrinterID: this.SelectedPrinter.IDPrinterID,
				IDCardTemplateID: this.SelectedTemplate.IDCardTemplateID,
			};

			this.isBusy = true;
			this.dataService.PhotoStationValidateRelease(parms).subscribe((data) => this.PhotoStationValidateRelease_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrintPriority
	//
	//-----------------------------------------------------------------------------------------------------
	onPrintPriority(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		if (this.lstPrinter.length > 0 && this.lstTemplate.length > 0) {
			if (this.SelectedPrinter.IDPrinterID > 0 && this.SelectedTemplate.IDCardTemplateID != "") {
				//
				//	Save Selected Printer/Template
				//
				this.localstorageService.setItem("PhotoStation_IDPrinterID_" + this.SchoolID + "_" + this.UserPersonID, this.SelectedPrinter.IDPrinterID);

				if (this.IsStaff == true) {
					this.localstorageService.setItem(
						"PhotoStation_Staff_IDCardTemplateID_" + this.SchoolID + "_" + this.UserPersonID,
						this.SelectedTemplate.IDCardTemplateID
					);
				} else {
					this.localstorageService.setItem(
						"PhotoStation_Student_IDCardTemplateID_" + this.SchoolID + "_" + this.UserPersonID,
						this.SelectedTemplate.IDCardTemplateID
					);
				}
				//
				//	Print The Card...
				//
				let ChargeFee: number = 0;

				if (this.IsChargePrintFee == true) {
					ChargeFee = this.PrintFee;
				}

				let parms: wsPhotoStationPrintParm = {
					PersonID: this.PersonID,
					IDPrinterID: this.SelectedPrinter.IDPrinterID,
					IDCardTemplateID: this.SelectedTemplate.IDCardTemplateID,
					ReprintFee: ChargeFee,
					QueuePriority: this.SelectedPriority,
					Result: "",
				};

				this.isBusy = true;
				this.dataService.PhotoStationPrintCard(parms).subscribe((data) => this.PhotoStationPrintCard_Complete(data));
			}
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPrintCard_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPrintCard_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
